import React from "react";
import freeReports from "../../PicesForPages/FreeReports.jpg";
import FreeReports from "../Form/FreeReports";

function GetInformativeFreeReports() {
  return (
    <div className="purchaseParent">
      <div className="purchasetopParent">
        <img
          src={freeReports}
          alt="freeReportsImage"
          className="background-video freeReportsImage"
        />
        <div className="purchasetopBox GetInformativeFreeReportsPageTopBox">
          {/* The existing Purchase span */}
          <span>Access Your Free Report</span>
        </div>
      </div>
      <div className="purchaseBottomParent">
        <div className="purchaseBottomBox freeReportsBottomBox">
          <div className="purchaseBottomLeftBox">
            <span className="purchaseBottomLeftContent">
              At <span className="brand_text">VIDHI MORTGAGE LLC</span> we’ve
              curated these complimentary reports to empower you with the
              knowledge needed to make confident and informed decisions.
            </span>
          </div>
          <FreeReports />
        </div>
      </div>
    </div>
  );
}

export default GetInformativeFreeReports;
